module.exports = __webpack_public_path__ + "assets/favicon.ico?5b7c6d11e4fd97bc4c69e6c057fa49d0";